enum EnumKpiValueType {
	Count = 1,
	SumMoney = 2,
	Percents = 3
}
export default EnumKpiValueType



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Enums/EnumKpiValueType.ts